import $ from "jquery";
import "slick-carousel";

const brandTab = () => {
  const init = () => {
    slick();
  };

  const slick = () => {
    const el = {
      slider: ".js-BrandTab__Slider",
      navs: ".js-BrandTab__Navigation",
    };

    if ($(el.slider || el.navs).length === 0) return;

    $(el.slider).slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: el.navs,
    });

    $(el.navs).slick({
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      speed: 1000,
      arrows: false,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      asNavFor: el.slider,
    });
  };

  init();
};

try {
  brandTab();
} catch (e) {
  console.error("brandtab: ", e);
}
